import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listClientSurveys,
  createSurveySend,
  getSurveyAggregate,
  getPublicSurveyInfo,
  submitSurveyResponse,
} from "./api";
import type { survey } from "@duress/shared";

export function useClientSurveys(clientId: string) {
  return useQuery({
    queryKey: ["surveys", clientId],
    queryFn: () => listClientSurveys(clientId),
    enabled: !!clientId,
  });
}

export function useCreateSurveySend(clientId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (contactIds: string[]) => createSurveySend(clientId, contactIds),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["surveys", clientId] });
    },
  });
}

export function useSurveyAggregate(industryFilter?: string) {
  return useQuery({
    queryKey: ["survey-aggregate", industryFilter ?? "all"],
    queryFn: () => getSurveyAggregate(industryFilter),
  });
}

export function usePublicSurveyInfo(token: string) {
  return useQuery({
    queryKey: ["public-survey", token],
    queryFn: () => getPublicSurveyInfo(token),
    enabled: !!token,
    retry: false,
  });
}

export function useSubmitSurveyResponse(token: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: survey.SubmitSurveyRequest) => submitSurveyResponse(token, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["public-survey", token] });
    },
  });
}
